import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
/**
 * A file field as a drop zone (21.10.2026): a dashed area that says what it takes. The native
 * file input lies over the whole area, invisible, so a click opens the chooser and a file
 * dropped on it lands in the input without code of ours; Tab reaches it like any input. A form
 * that sends the input (`name`) works as before, and its reset empties the area too. A chosen
 * file names itself in the area. `compact` is the one-line zone for a table cell.
 */
export function FileDrop({ id, name, accept, prompt = "Datei auswählen oder hierher ziehen", hint, label, describedBy, required = false, compact = false, disabled = false, onChange, }) {
    const input = useRef(null);
    const [over, setOver] = useState(false);
    const [chosen, setChosen] = useState(null);
    const hintId = `${id}-hinweis`;
    useEffect(() => {
        const form = input.current?.form;
        if (form === null || form === undefined) {
            return undefined;
        }
        const reset = () => {
            setChosen(null);
        };
        form.addEventListener("reset", reset);
        return () => {
            form.removeEventListener("reset", reset);
        };
    }, []);
    return (_jsxs("div", { className: `relative mt-1.5 flex flex-col items-center justify-center gap-1 rounded-md border border-dashed text-center text-sm focus-within:outline-3 focus-within:outline-offset-2 focus-within:outline-ink ${compact ? "px-3 py-2" : "min-h-24 px-4 py-5"} ${over ? "border-brand bg-brand-soft" : "border-line-strong bg-surface-sunken hover:border-brand"} ${disabled ? "opacity-50" : ""}`, children: [compact ? null : (_jsx("svg", { "aria-hidden": "true", viewBox: "0 0 24 24", className: "size-6 text-ink-muted", fill: "none", stroke: "currentColor", strokeWidth: "1.75", strokeLinecap: "round", strokeLinejoin: "round", children: _jsx("path", { d: "M12 15V4m0 0L8 8m4-4 4 4M4 15v3a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-3" }) })), _jsx("label", { htmlFor: id, className: "max-w-full truncate font-medium text-ink", children: chosen ?? prompt }), hint === undefined ? null : (_jsx("span", { id: hintId, className: "text-xs text-ink-muted", children: hint })), _jsx("input", { ref: input, id: id, name: name, type: "file", accept: accept, required: required, disabled: disabled, "aria-label": label, className: "absolute inset-0 size-full cursor-pointer opacity-0 disabled:cursor-not-allowed", "aria-describedby": describedBy ?? (hint === undefined ? undefined : hintId), onDragEnter: () => {
                    setOver(true);
                }, onDragLeave: () => {
                    setOver(false);
                }, onDrop: () => {
                    setOver(false);
                }, onChange: (event) => {
                    const file = event.target.files?.[0] ?? null;
                    setChosen(file?.name ?? null);
                    onChange?.(file);
                } })] }));
}
//# sourceMappingURL=FileDrop.js.map